(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pigu-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
window.PIGU_KVADRATU_CATEGORIES = [
  {
    slug: "populiariausios-prekes",
    title: "Populiariausios prekės",
    icon: "icon-package",
    description: "Populiariausios prekės iš viso asortimento.",
    subcategories: [],
  },
  {
    slug: "namu-apyvokos-prekes",
    title: "Namų apyvokos prekės",
    icon: "icon-home",
    description: "Baldai, tekstilė, apšvietimas ir daiktai jaukesniems namams.",
    subcategories: [],
  },
  {
    slug: "virtuve-ir-buitis",
    title: "Virtuvė ir buitis",
    icon: "icon-kitchen",
    description: "Virtuvės reikmenys, indai, puodai ir kasdienės buities prekės.",
    subcategories: [],
  },
  {
    slug: "grozis",
    title: "Grožis",
    icon: "icon-health",
    description: "Grožio, higienos ir kasdienės priežiūros prekės.",
    subcategories: [],
  },
];

// Realūs produktai bus įkelti vėliau. Produktai su popular: true automatiškai atsiras homepage bloke "Populiarūs pasiūlymai".
window.PIGU_KVADRATU_PRODUCTS = [];

window.PIGU_KVADRATU_TESTIMONIALS = [
  {
    name: "Ona Petrauskienė",
    rating: 5,
    text: "Prekė visiškai atitiko aprašymą. Gavau tai, ko tikėjausi, viskas tvarkoje.",
  },
  {
    name: "Antanas Jankauskas",
    rating: 5,
    text: "Kokybė gera, prekė patogi naudoti kasdien. Likau patenkintas pirkiniu.",
  },
  {
    name: "Dalia Kavaliauskė",
    rating: 4,
    text: "Viskas gerai, prekė atkeliavo tvarkinga. Naudoju jau kelias dienas, nusiskundimų neturiu.",
  },
  {
    name: "Vytautas Stankevičius",
    rating: 5,
    text: "Prekė atrodo kokybiška ir veikia taip, kaip nurodyta. Pirkiniu esu patenkintas.",
  },
  {
    name: "Regina Kazlauskienė",
    rating: 5,
    text: "Labai patiko prekės kokybė. Viskas buvo supakuota tvarkingai ir saugiai.",
  },
  {
    name: "Jonas Petrauskas",
    rating: 4,
    text: "Prekė gera, aprašymas atitiko realybę. Už tokią kainą tikrai verta.",
  },
  {
    name: "Irena Vaitkienė",
    rating: 5,
    text: "Patogu naudoti, aiški paskirtis ir gera kokybė. Pirkčiau dar kartą.",
  },
  {
    name: "Algirdas Rimkus",
    rating: 5,
    text: "Viskas atitiko lūkesčius. Prekė praktiška ir atrodo patikimai.",
  },
  {
    name: "Birutė Paulauskienė",
    rating: 4,
    text: "Prekė tvarkinga, be defektų. Galėtų būti kiek išsamesnė instrukcija, bet viskas aišku.",
  },
  {
    name: "Petras Butkus",
    rating: 5,
    text: "Gavau gerą produktą už gerą kainą. Kokybė maloniai nustebino.",
  },
  {
    name: "Laima Žukauskienė",
    rating: 5,
    text: "Prekė labai pravertė namuose. Paprasta, patogi ir atrodo ilgaamžė.",
  },
  {
    name: "Kazys Mockus",
    rating: 4,
    text: "Viskas gerai, produktas toks, kaip parodyta. Naudojasi paprastai.",
  },
  {
    name: "Rasa Ivanauskienė",
    rating: 5,
    text: "Patiko, kad prekė atrodo solidžiai. Jokio nemalonaus kvapo ar broko nepastebėjau.",
  },
  {
    name: "Stasys Norkus",
    rating: 5,
    text: "Prekė kokybiška, tvirta ir atitiko mano poreikius. Viskas gerai.",
  },
  {
    name: "Janina Šimkienė",
    rating: 4,
    text: "Produktas patogus, dydis tiko, spalva ir medžiaga atitiko aprašymą.",
  },
  {
    name: "Arvydas Kavaliauskas",
    rating: 5,
    text: "Likau patenkintas. Prekė paprasta naudoti ir tikrai naudinga kasdienai.",
  },
  {
    name: "Nijolė Urbonienė",
    rating: 5,
    text: "Labai gera prekė. Viskas veikė iš karto, papildomai nieko nereikėjo aiškintis.",
  },
  {
    name: "Mindaugas Balčiūnas",
    rating: 4,
    text: "Prekė atitiko kainą ir kokybę. Viskas buvo taip, kaip tikėjausi.",
  },
  {
    name: "Aldona Grigaitienė",
    rating: 5,
    text: "Gražiai atrodo, patogu laikyti ir naudoti. Pirkiniu esu labai patenkinta.",
  },
  {
    name: "Vincas Matulaitis",
    rating: 5,
    text: "Produktas geras, be priekaištų. Viskas atitiko ir veikia tvarkingai.",
  },
];

window.PIGU_KVADRATU_INFO_PAGES = [
  { slug: "mano-paskyra", title: "Mano paskyra", href: "/pages/mano-paskyra" },
  { slug: "megstamiausi", title: "Mėgstamiausi", href: "/pages/megstamiausi" },
  { slug: "krepselis", title: "Krepšelis", href: "/cart" },
  { slug: "sekti-uzsakyma", title: "Sekti užsakymą", href: "/pages/sekti-uzsakyma" },
  { slug: "kontaktai", title: "Kontaktai", href: "/pages/kontaktai" },
  { slug: "pristatymas", title: "Pristatymas", href: "/pages/pristatymas" },
  { slug: "taisykles-ir-politikos", title: "Taisyklės ir politikos", href: "/pages/taisykles-ir-politikos" },
  { slug: "privatumo-politika", title: "Privatumo politika", href: "/pages/privatumo-politika" },
  { slug: "salygos-ir-taisykles", title: "Sąlygos ir taisyklės", href: "/pages/salygos-ir-taisykles" },
  { slug: "pinigu-grazinimo-politika", title: "Pinigų grąžinimo politika", href: "/pages/pinigu-grazinimo-politika" },
  { slug: "pristatymo-politika", title: "Pristatymo politika", href: "/pages/pristatymo-politika" },
];

window.PIGU_KVADRATU_FILTERS = {
  "populiariausios-prekes": [
    { type: "price", title: "Kaina" },
    { type: "checkbox", title: "Kategorija", options: ["Namų apyvokos prekės", "Virtuvė ir buitis", "Grožis"] },
    { type: "checkbox", title: "Nuolaida", options: ["Iki 10%", "10-20%", "20-30%", "30% ir daugiau"] },
  ],
  "namu-apyvokos-prekes": [
    { type: "price", title: "Kaina" },
    { type: "checkbox", title: "Kambarys", options: ["Svetainė", "Miegamasis", "Virtuvė", "Prieškambaris", "Vonios kambarys"] },
    { type: "checkbox", title: "Medžiaga", options: ["Mediena", "Metalas", "Stiklas", "Audinys", "Dirbtinė oda"] },
    { type: "checkbox", title: "Spalva", options: ["Balta", "Pilka", "Mėlyna", "Ruda", "Juoda"] },
  ],
  "virtuve-ir-buitis": [
    { type: "price", title: "Kaina" },
    { type: "checkbox", title: "Paskirtis", options: ["Maisto gaminimas", "Serviravimas", "Laikymas", "Valymas", "Skalbimas"] },
    { type: "checkbox", title: "Medžiaga", options: ["Nerūdijantis plienas", "Keramika", "Stiklas", "Plastikas", "Mediena"] },
    { type: "checkbox", title: "Talpa", options: ["Iki 1 l", "1-3 l", "3-5 l", "Daugiau nei 5 l"] },
  ],
  grozis: [
    { type: "price", title: "Kaina" },
    { type: "checkbox", title: "Paskirtis", options: ["Veidui", "Kūnui", "Plaukams", "Higienai", "Kasdienai"] },
    { type: "checkbox", title: "Kam skirta", options: ["Moterims", "Vyrams", "Visai šeimai"] },
    { type: "checkbox", title: "Savybės", options: ["Lengva naudoti", "Kompaktiška", "Be kvapiklių", "Jautriai odai"] },
  ],
};

window.PIGU_KVADRATU_PAGE_CONTENT = {
  "mano-paskyra": {
    title: "Mano paskyra",
    intro: "Atskiras kliento puslapis registracijai, prisijungimui, užsakymams ir siuntos sekimui.",
    sections: [
      ["Registracija", "Klientas galės prisijungti arba registruotis el. paštu per Shopify kliento paskyrą."],
      ["Mano užsakymai", "Prisijungus čia bus pasiekiama užsakymų istorija."],
      ["Siuntos sekimas", "Kai užsakymas bus išsiųstas, pirkėjas galės matyti siuntos sekimo informaciją."],
    ],
  },
  "sekti-uzsakyma": {
    title: "Sekti užsakymą",
    intro: "Puslapis skirtas užsakymo ir siuntos sekimo informacijai.",
    sections: [
      ["Užsakymo būsena", "Prisijungę klientai gali matyti savo užsakymų istoriją paskyroje."],
      ["Siuntos numeris", "Kai užsakymas bus išsiųstas, sekimo numeris bus pateikiamas el. paštu arba paskyroje."],
      ["Pagalba", "Jeigu kyla klausimų dėl siuntos, pirkėjas gali kreiptis į klientų aptarnavimą."],
    ],
  },
  megstamiausi: {
    title: "Mėgstamiausi",
    intro: "Atskiras puslapis pirkėjo išsaugotoms prekėms.",
    sections: [
      ["Išsaugotos prekės", "Kai pirkėjas pažymės prekę širdelės ikonėle, ji galės būti rodoma šiame puslapyje."],
      ["Greita peržiūra", "Vėliau čia galėsime rodyti realias išsaugotas prekes pagal kliento paskyrą."],
      ["Patogus grįžimas", "Pirkėjas galės grįžti prie mėgstamų prekių prieš pirkdamas."],
    ],
  },
  krepselis: {
    title: "Krepšelis",
    intro: "Atskiras pirkinių krepšelio puslapis.",
    sections: [
      ["Krepšelio turinys", "Čia bus rodomos pirkėjo pasirinktos prekės."],
      ["Saugus atsiskaitymas", "Kai prekės bus krepšelyje, pirkėjas galės pereiti prie Shopify atsiskaitymo."],
      ["Tuščias krepšelis", "Jeigu prekių nėra, pirkėjas matys aiškią žinutę ir nuorodą grįžti į kategorijas."],
    ],
  },
  kontaktai: {
    title: "Kontaktai",
    intro: "Jeigu turite klausimų dėl prekių, užsakymo, pristatymo ar grąžinimo, susisiekite su Pigu Kvadratu komanda el. paštu.",
    sections: [
      ["El. paštas", "info@pigukvadratu.lt"],
      ["Atsakymo terminas", "Į užklausas atsakome ne vėliau kaip per 20 darbo dienų nuo kreipimosi gavimo dienos."],
      ["Apie mus", "Pigu Kvadratu yra universali internetinė parduotuvė, sukurta tam, kad skirtingų prekių paieška būtų paprastesnė, greitesnė ir patogesnė vienoje vietoje."],
      ["Mūsų tikslas", "Siekiame pasiūlyti kruopščiai atrinktas prekes už konkurencingą kainą, užtikrinti patogų apsipirkimą, greitą aptarnavimą ir nuolat atnaujinamą asortimentą."],
      ["Ką rasite parduotuvėje", "Namų apyvokos prekės, elektronika, laisvalaikio ir sporto reikmenys, prekės vaikams, grožiui, augintiniams bei daugybė kitų naudingų produktų - visa tai rasite vienoje vietoje."],
      ["Vartotojų teisės", "Prašymą ar skundą dėl mūsų elektroninėje parduotuvėje įsigytos prekės ar paslaugos galite pateikti Valstybinei vartotojų teisių apsaugos tarnybai: A. Goštauto g. 12, 01108 Vilnius, el. p. tarnyba@vvtat.lt, tel. +370 5 2626760, interneto svetainė https://vvtat.lrv.lt/."],
    ],
  },
  pristatymas: {
    title: "Pristatymas",
    intro: "Čia pateikiama pagrindinė informacija apie užsakymo išsiuntimą, pristatymo terminus ir siuntos atsiėmimą.",
    sections: [
      ["Užsakymo išsiuntimas", "Užsakymo išsiuntimo terminas yra 1-3 darbo dienos."],
      ["Pristatymo terminas", "Jeigu prie prekės nėra nurodytas kitas pristatymo terminas, prekės pristatomos per 7-18 dienų į artimiausią pasirinktą paštomatą, priklausomai nuo pasirinkto produkto."],
      ["Pristatymo kaina", "Prekės pristatomos nemokamai į pasirinktą paštomatą."],
      ["Atsiėmimas", "Siuntiniui atvykus į paštomatą, būsite informuoti SMS žinute ir galėsite siuntą atsiimti jums patogiu metu."],
      ["Svarbi informacija", "Užsakydamas prekes klientas turi nurodyti tikslią pristatymo vietą, asmenį, kuris atsiims prekes, ir tikslų telefono numerį."],
      ["Jeigu kyla nesklandumų", "Jeigu kyla nesklandumų dėl pristatymo, parduotuvė susisieks su klientu ir ieškos geriausio sprendimo."],
    ],
  },
  "taisykles-ir-politikos": {
    title: "Taisyklės ir politikos",
    intro: "Bendras puslapis, kuriame pirkėjas gali rasti visas svarbiausias parduotuvės taisykles vienoje vietoje.",
    sections: [
      ["Privatumo politika", "Paaiškina, kaip tvarkomi pirkėjo duomenys."],
      ["Sąlygos ir taisyklės", "Apibrėžia naudojimosi parduotuve ir pirkimo sąlygas."],
      ["Pinigų grąžinimo politika", "Paaiškina grąžinimo ir pinigų grąžinimo procesą."],
      ["Pristatymo politika", "Aprašo pristatymo būdus, terminus ir sąlygas."],
    ],
  },
  "privatumo-politika": {
    title: "Privatumo politika",
    intro: "Ši privatumo politika paaiškina, kaip internetinė parduotuvė Pigu Kvadratu renka, naudoja, saugo ir tvarko klientų bei svetainės lankytojų asmens duomenis.",
    sections: [
      ["Bendrosios nuostatos", "Naudodamiesi internetine parduotuve ir pateikdami savo asmens duomenis, sutinkate su šioje privatumo politikoje nustatytomis sąlygomis. Asmens duomenys tvarkomi laikantis BDAR, Lietuvos Respublikos teisės aktų ir kitų taikomų reikalavimų."],
      ["Kokius duomenis renkame", "Pateikdami užsakymą arba registruodamiesi galite pateikti vardą, pavardę, pristatymo adresą, telefono numerį, el. pašto adresą, mokėjimo informaciją ir kitą informaciją, reikalingą užsakymo vykdymui."],
      ["Techninė informacija", "Taip pat gali būti renkama techninė informacija: IP adresas, naršyklės tipas, įrenginio informacija, slapukų duomenys ir naršymo svetainėje statistika."],
      ["Duomenų tvarkymo tikslai", "Duomenys naudojami užsakymams priimti ir administruoti, prekėms pristatyti, sąskaitoms išrašyti, klientų aptarnavimui, pristatymo ar grąžinimo klausimams spręsti, teisinėms prievolėms vykdyti ir parduotuvės veiklai tobulinti."],
      ["Duomenų perdavimas", "Jūsų asmens duomenys gali būti perduodami kurjerių ir siuntų pristatymo tarnyboms, mokėjimų paslaugų teikėjams, buhalterinės apskaitos ir IT paslaugų teikėjams bei valstybinėms institucijoms, kai to reikalauja teisės aktai."],
      ["Duomenų saugojimas ir apsauga", "Asmens duomenys saugomi tiek laiko, kiek būtina nurodytiems tikslams pasiekti arba kiek reikalauja teisės aktai. Taikomos techninės ir organizacinės priemonės duomenims apsaugoti."],
      ["Jūsų teisės", "Jūs turite teisę susipažinti su savo duomenimis, reikalauti juos ištaisyti ar ištrinti, apriboti duomenų tvarkymą, nesutikti su tvarkymu, atšaukti sutikimą ir pateikti skundą atsakingai institucijai."],
      ["Slapukai", "Svetainėje gali būti naudojami slapukai, siekiant užtikrinti tinkamą svetainės veikimą, analizuoti lankytojų srautus ir gerinti naudotojų patirtį."],
      ["Kontaktinė informacija", "Privatumo klausimais susisiekite el. paštu info@pigukvadratu.lt. Į užklausas atsakome ne vėliau kaip per 20 darbo dienų nuo kreipimosi gavimo dienos."],
    ],
  },
  "salygos-ir-taisykles": {
    title: "Sąlygos ir taisyklės",
    intro: "Atskiras puslapis parduotuvės naudojimosi ir pirkimo sąlygoms.",
    sections: [
      ["Pirkimas", "Pirkėjas atsako už teisingai pateiktus duomenis užsakymo metu."],
      ["Apmokėjimas", "Galimi mokėjimo būdai priklausys nuo Shopify nustatymų ir prijungtų mokėjimo paslaugų."],
      ["Atsakomybė", "Galutinės sąlygos turi būti pritaikytos realiai parduotuvės veiklai."],
    ],
  },
  "pinigu-grazinimo-politika": {
    title: "Pinigų grąžinimo politika",
    intro: "Šiame puslapyje pateikiama prekių grąžinimo, keitimo ir pinigų grąžinimo informacija.",
    sections: [
      ["Grąžinimo terminas", "Jeigu įsigyta prekė jums netiko, ją galite grąžinti per 30 kalendorinių dienų nuo užsakymo gavimo dienos, jei prekė atitinka grąžinimo sąlygas."],
      ["Grąžinimo sąlygos", "Prekė turi būti originalioje pakuotėje su visais komplekte buvusiais priedais, nenaudota, nesugadinta ir nepraradusi prekinės išvaizdos. Šis reikalavimas netaikomas nekokybiškoms ar brokuotoms prekėms."],
      ["Prekės, kurios negali būti grąžinamos", "Negrąžinamos pagal individualų užsakymą pagamintos prekės, greitai gendančios prekės, prekės, kurių galiojimo laikas pasibaigęs, higienos ar sveikatos apsaugos prekės, jei jų pakuotė buvo atidaryta po pristatymo, ir prekės, kurios po pristatymo buvo neatsiejamai sumaišytos ar sujungtos su kitais daiktais."],
      ["Nekokybiškos prekės", "Jeigu gavote nekokybišką arba brokuotą prekę, ją galite grąžinti per 30 kalendorinių dienų nuo užsakymo gavimo dienos. Nekokybišką prekę nemokamai pakeisime nauja, o jei pakeisti negalėsime, grąžinsime visą sumokėtą sumą, įskaitant pristatymo išlaidas."],
      ["Grąžinimo procedūra", "Norėdami grąžinti arba pakeisti prekę, atsiųskite laisvos formos prašymą el. paštu info@pigukvadratu.lt. Laiške nurodykite užsakymo numerį, grąžinimo priežastį, grąžinamą prekę ir savo kontaktinius duomenis."],
      ["Atsakymo terminas", "Per 1-2 darbo dienas pateiksime išsamią informaciją apie tolimesnę grąžinimo eigą. Pasiliekame teisę nepriimti grąžinamų prekių, jei nesilaikoma šiame puslapyje nurodytos grąžinimo tvarkos."],
    ],
  },
  "pristatymo-politika": {
    title: "Pristatymo politika",
    intro: "Šiame puslapyje pateikiamos pristatymo taisyklės, terminai ir svarbiausia informacija apie užsakymo gavimą.",
    sections: [
      ["Užsakymo išsiuntimas", "Užsakymo išsiuntimo terminas yra 1-3 darbo dienos."],
      ["Pristatymo terminas", "Jeigu prie prekės nėra nurodytas kitas pristatymo terminas, prekės pristatomos per 7-18 dienų į artimiausią pasirinktą paštomatą, priklausomai nuo pasirinkto produkto."],
      ["Nemokamas pristatymas", "Prekės pristatomos nemokamai į pasirinktą paštomatą."],
      ["Kliento duomenys", "Klientas, užsakydamas prekes, įsipareigoja nurodyti pristatymo vietą, asmenį, kuris atsiims prekes, ir tikslų telefono numerį."],
      ["Siuntos atsiėmimas", "Siuntiniui atvykus į paštomatą, būsite informuoti SMS žinute ir galėsite siuntą atsiimti jums patogiu metu."],
      ["Netinkama ar trūkstama prekė", "Jeigu priėmę prekes pastebite, kad siuntoje nėra tinkamos prekės, nedelsdami informuokite parduotuvę el. paštu info@pigukvadratu.lt."],
    ],
  },
};


const categories = window.PIGU_KVADRATU_CATEGORIES || [];
const infoPages = window.PIGU_KVADRATU_INFO_PAGES || [];
const products = window.PIGU_KVADRATU_PRODUCTS || [];
const testimonials = window.PIGU_KVADRATU_TESTIMONIALS || [];

const categoryPanelList = document.querySelector("#categoryPanelList");
const categoryTiles = document.querySelector("#categoryTiles");
const productGrid = document.querySelector("#productGrid");
const contentPanel = document.querySelector("#contentPanel");
const toast = document.querySelector("#toast");
const cartCount = document.querySelector("#cartCount");
const favoriteCount = document.querySelector("#favoriteCount");
const testimonialGrid = document.querySelector("#testimonialGrid");
const showMoreTestimonialsButton = document.querySelector("#showMoreTestimonials");

const formatter = new Intl.NumberFormat("lt-LT", { style: "currency", currency: "EUR" });
const cart = new Map();
const favorites = new Set();
let visibleTestimonials = 6;
let registeredEmail = "";

function categoryHref(category) {
  return category.href || `/collections/${category.slug}`;
}

function icon(name) {
  return `<svg><use href="#${name}"></use></svg>`;
}

function money(value) {
  return formatter.format(value);
}

function productById(id) {
  return products.find((product) => product.id === id);
}

function renderCategoryPanel() {
  if (!categoryPanelList) {
    return;
  }

  categoryPanelList.innerHTML = categories
    .map(
      (category) => `
        <a href="${categoryHref(category)}">
          ${icon(category.icon)}
          <span>${category.title}</span>
          <svg><use href="#icon-chevron"></use></svg>
        </a>
      `
    )
    .join("");
}

function renderCategoryTiles() {
  if (!categoryTiles) {
    return;
  }

  categoryTiles.innerHTML = categories
    .slice(1)
    .map(
      (category) => `
        <a href="${categoryHref(category)}">
          ${icon(category.icon)}
          <span>${category.title}</span>
        </a>
      `
    )
    .join("");
}

function productCard(product) {
  const active = favorites.has(product.id) ? "is-active" : "";

  return `
    <article class="product-card">
      <a class="product-visual pos-${product.pos || 0}" href="/collections/${product.category}" aria-label="${product.title}">
        ${product.discount ? `<span class="discount">${product.discount}</span>` : ""}
      </a>
      <div class="product-info">
        <h3>${product.title}</h3>
        <div class="price-row">
          <span class="price">${money(product.price)}</span>
          ${product.oldPrice ? `<span class="old-price">${money(product.oldPrice)}</span>` : ""}
        </div>
        <div class="product-actions">
          <button type="button" data-add="${product.id}">Į krepšelį</button>
          <button type="button" class="${active}" data-wishlist="${product.id}" aria-label="Įtraukti į mėgstamiausius">
            <svg><use href="#icon-heart"></use></svg>
          </button>
        </div>
      </div>
    </article>
  `;
}

function renderPopularProducts() {
  if (!productGrid) {
    return;
  }

  const popularProducts = products.filter((product) => product.popular);
  productGrid.innerHTML = popularProducts.length
    ? popularProducts.map(productCard).join("")
    : `
      <section class="empty-products product-empty">
        <h2>Produktų kol kas nėra</h2>
        <p>Kai įkelsite realius produktus ir pažymėsite juos kaip populiarius, jie automatiškai atsiras šiame bloke.</p>
        <a class="button primary" href="/collections">Peržiūrėti kategorijas</a>
      </section>
    `;
}

function stars(rating) {
  return "★".repeat(rating) + "☆".repeat(5 - rating);
}

function renderTestimonials() {
  if (!testimonialGrid) {
    return;
  }

  testimonialGrid.innerHTML = testimonials
    .slice(0, visibleTestimonials)
    .map(
      (testimonial) => `
        <article class="testimonial-card">
          <div class="testimonial-content">
            <div class="stars" aria-label="${testimonial.rating} iš 5 žvaigždučių">${stars(testimonial.rating)}</div>
            <p>${testimonial.text}</p>
          </div>
          <aside class="buyer-proof">
            <span>Patvirtintas pirkėjas</span>
            <strong>${testimonial.name}</strong>
          </aside>
        </article>
      `
    )
    .join("");

  if (showMoreTestimonialsButton) {
    showMoreTestimonialsButton.hidden = visibleTestimonials >= testimonials.length;
    showMoreTestimonialsButton.textContent =
      visibleTestimonials >= testimonials.length ? "Visi atsiliepimai parodyti" : "Rodyti daugiau atsiliepimų";
  }
}

function updateCounts() {
  cartCount.textContent = [...cart.values()].reduce((sum, qty) => sum + qty, 0);
  favoriteCount.textContent = favorites.size;
}

function showPanel(html, scroll = true) {
  contentPanel.innerHTML = html;
  contentPanel.classList.add("is-visible");
  if (scroll) {
    contentPanel.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function renderAccountPanel() {
  if (registeredEmail) {
    renderAccountDashboard(registeredEmail);
    return;
  }

  showPanel(`
    <div class="dynamic-layout account-layout">
      <div>
        <h2>Mano paskyra</h2>
        <p>Pirmiausia prisiregistruokite el. paštu. Po registracijos čia matysite savo užsakymus ir galėsite sekti siuntą.</p>
        <form class="account-form" data-account-register>
          <label>
            El. paštas
            <input type="email" name="email" placeholder="vardas@pastas.lt" required>
          </label>
          <button class="button primary" type="submit">Registruotis</button>
        </form>
      </div>
      <aside class="dynamic-card">
        <strong>Po registracijos</strong>
        <p>Šioje vietoje bus užsakymų istorija, siuntos sekimas ir paskyros informacija.</p>
      </aside>
    </div>
  `);
}

function renderAccountDashboard(email) {
  registeredEmail = email;
  showPanel(`
    <div class="dynamic-layout account-layout">
      <div>
        <h2>Mano paskyra</h2>
        <p>Paskyra paruošta el. paštui <strong>${email}</strong>.</p>
        <div class="account-dashboard">
          <section>
            <strong>Mano užsakymai</strong>
            <p>Užsakymų kol kas nėra. Kai apsipirksite, čia matysite visą užsakymų istoriją.</p>
          </section>
          <section>
            <strong>Siuntos sekimas</strong>
            <p>Kai užsakymas bus išsiųstas, čia atsiras siuntos sekimo informacija.</p>
          </section>
        </div>
      </div>
      <aside class="dynamic-card">
        <strong>Pagalba</strong>
        <a class="button primary panel-action" href="/pages/kontaktai">Susisiekti</a>
      </aside>
    </div>
  `, false);
}

function renderHeaderPanel(panel) {
  if (panel === "account") {
    renderAccountPanel();
    return;
  }

  const panels = {
    favorites: {
      title: "Mėgstamiausi",
      text: favorites.size
        ? `Išsaugota prekių: ${favorites.size}.`
        : "Dar neturite mėgstamiausių prekių. Kai įkelsime produktus, galėsite juos išsisaugoti paspausdami širdelę.",
      action: "/collections/populiariausios-prekes",
      actionText: "Peržiūrėti kategoriją",
    },
    cart: {
      title: "Krepšelis",
      text: cart.size ? "Krepšelyje yra pasirinktų prekių." : "Krepšelis kol kas tuščias.",
      action: "/pages/pristatymo-politika",
      actionText: "Pristatymo politika",
    },
  };
  const data = panels[panel] || panels.cart;
  showPanel(`
    <div class="dynamic-layout">
      <div>
        <h2>${data.title}</h2>
        <p>${data.text}</p>
      </div>
      <aside class="dynamic-card">
        <strong>Greita nuoroda</strong>
        <a class="button primary panel-action" href="${data.action}">${data.actionText}</a>
      </aside>
    </div>
  `);
}

function renderSearchResults(query) {
  const normalized = query.trim().toLowerCase();
  const productMatches = products.filter((product) => product.title.toLowerCase().includes(normalized));
  const categoryMatches = categories.filter((category) =>
    [category.title, category.description].join(" ").toLowerCase().includes(normalized)
  );
  const pageMatches = infoPages.filter((page) => page.title.toLowerCase().includes(normalized));

  const resultHtml = [
    ...productMatches.map(
      (product) => `
        <a class="result-row" href="/collections/${product.category}">
          ${icon("icon-package")}
          <span><strong>${product.title}</strong><small>${money(product.price)}</small></span>
        </a>
      `
    ),
    ...categoryMatches.map(
      (category) => `
        <a class="result-row" href="${categoryHref(category)}">
          ${icon(category.icon)}
          <span><strong>${category.title}</strong><small>${category.description}</small></span>
        </a>
      `
    ),
    ...pageMatches.map(
      (page) => `
        <a class="result-row" href="${page.href}">
          ${icon("icon-package")}
          <span><strong>${page.title}</strong><small>Informacinis puslapis</small></span>
        </a>
      `
    ),
  ].join("");

  showPanel(`
    <div class="dynamic-layout">
      <div>
        <h2>Paieškos rezultatai</h2>
        <p>Ieškota: <strong>${query}</strong></p>
        <div class="result-list">${resultHtml || "<p>Nieko nerasta. Pabandykite ieškoti „namai“, „virtuvė“, „grožis“ arba „pristatymas“.</p>"}</div>
      </div>
      <aside class="dynamic-card">
        <strong>Paieška</strong>
        <p>Paieška rodo prekes, kategorijas ir informacinius puslapius.</p>
      </aside>
    </div>
  `);
}

let toastTimer;
function showToast(message) {
  toast.textContent = message;
  toast.classList.add("show");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove("show"), 2400);
}

document.addEventListener("click", (event) => {
  const panelButton = event.target.closest("[data-panel]");
  if (panelButton) {
    renderHeaderPanel(panelButton.dataset.panel);
    return;
  }

  const addButton = event.target.closest("[data-add]");
  if (addButton) {
    const product = productById(addButton.dataset.add);
    if (!product) return;
    cart.set(product.id, (cart.get(product.id) || 0) + 1);
    updateCounts();
    showToast(`Prekė „${product.title}“ įdėta į krepšelį.`);
    return;
  }

  const favoriteButton = event.target.closest("[data-wishlist]");
  if (favoriteButton) {
    const id = favoriteButton.dataset.wishlist;
    const product = productById(id);
    if (!product) return;
    if (favorites.has(id)) {
      favorites.delete(id);
      showToast("Prekė pašalinta iš mėgstamiausių.");
    } else {
      favorites.add(id);
      showToast(`Prekė „${product.title}“ pridėta prie mėgstamiausių.`);
    }
    updateCounts();
    renderPopularProducts();
    return;
  }

  if (event.target.closest("#categoryToggle")) {
    document.querySelector("#categoryPanel").classList.toggle("open");
    return;
  }

  if (event.target.closest("#showMoreTestimonials")) {
    visibleTestimonials += 6;
    renderTestimonials();
  }
});

document.addEventListener("submit", (event) => {
  const accountForm = event.target.closest("[data-account-register]");
  if (!accountForm) {
    return;
  }

  event.preventDefault();
  const email = accountForm.elements.email.value.trim();
  if (!email) {
    showToast("Įveskite el. pašto adresą.");
    return;
  }
  renderAccountDashboard(email);
  showToast("Paskyra paruošta.");
});

document.querySelector("#searchForm").addEventListener("submit", (event) => {
  event.preventDefault();
  const query = document.querySelector("#searchInput").value.trim();
  if (!query) {
    showToast("Įveskite paieškos žodį.");
    return;
  }
  renderSearchResults(query);
});

renderCategoryPanel();
renderCategoryTiles();
renderPopularProducts();
renderTestimonials();
updateCounts();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pigu-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pigu-product').forEach(s=>{const slides=[...s.querySelectorAll('.pigu-gallery__slide')],thumbs=[...s.querySelectorAll('.pigu-gallery__thumb')],main=s.querySelector('[data-gallery-main]'),variant=s.querySelector('[data-variant-id]'),qty=s.querySelector('input[name="quantity"]'),volume=s.querySelector('[data-volume-box]'),volumeText=s.querySelector('[data-volume-text]');let active=0,startX=0,startY=0;const show=i=>{if(!slides.length)return;active=(i+slides.length)%slides.length;slides.forEach((x,n)=>x.classList.toggle('is-active',n===active));thumbs.forEach((x,n)=>x.classList.toggle('is-active',n===active));if(thumbs[active])thumbs[active].scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'})};const showMedia=id=>{if(!id)return;const index=slides.findIndex(x=>x.dataset.mediaId===id);if(index>=0)show(index)};const updateVolume=()=>{if(!qty||!volume||!volumeText)return;const count=Math.max(1,Number(qty.value||1));volume.classList.toggle('is-active',count>=2);volumeText.textContent=count>=2?'Pasirinkote '+count+' vnt. Papildoma nuolaida paruošta šiam užsakymui.':'Pasirinkite 2 ar daugiau vienetų ir matysite papildomos nuolaidos žinutę.'};thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));if(main){main.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;startY=e.touches[0].clientY},{passive:true});main.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){show(active+(dx<0?1:-1))}},{passive:true})}s.querySelectorAll('input[name="variant-choice"]').forEach(x=>x.addEventListener('change',()=>{if(variant)variant.value=x.value;showMedia(x.dataset.mediaId)}));const checked=s.querySelector('input[name="variant-choice"]:checked');if(checked)showMedia(checked.dataset.mediaId);const m=s.querySelector('[data-minus]'),p=s.querySelector('[data-plus]');if(m&&p&&qty){m.addEventListener('click',()=>{qty.value=Math.max(1,Number(qty.value||1)-1);updateVolume()});p.addEventListener('click',()=>{qty.value=Number(qty.value||1)+1;updateVolume()});qty.addEventListener('input',updateVolume);updateVolume()}});

  } catch(e) { console.error(e); }
})();
})();
